import {
  convertUTCDateInTimeZone,
  getCurrentDate,
  getValidDate,
  isDateBetweenStartAndEnd,
} from './date';
const moment = require('moment');

export function getNearestUpcomingPeriod(allPeriods, timezone) {
  let nearestPeriod = null;
  if (allPeriods && allPeriods.length > 0) {
    const now = convertUTCDateInTimeZone(getCurrentDate(), timezone);
    const remainingPeriods = allPeriods.filter((p) => p.periodStartdate > now);
    remainingPeriods.sort((a, b) => a.periodStartdate - b.periodStartdate);
    nearestPeriod = {
      ...remainingPeriods[0],
    };
  }
  return nearestPeriod;
}

export function getNearestPeriodInDate(allPeriods, date) {
  let nearestPeriod = null;
  if (allPeriods && allPeriods.length > 0) {
    nearestPeriod = allPeriods.find((period) =>
      isDateBetweenStartAndEnd(date, period.periodStartdate, period.periodEnddate));
  }
  return nearestPeriod;
}


export function getNearestPeriodFromNow(periods, key = 'periodStartdate') {
  const now = getCurrentDate(false);
  const dateDiffArray = periods.map((period) => {
    const date = getValidDate(period[key]);
    return Math.abs(now.diff(date, 'days'));
  });
  const index = dateDiffArray.indexOf(
      dateDiffArray.reduce((a, b) => Math.min(a, b)),
  );
  return {
    period: periods[index],
    index,
    diff: dateDiffArray[index],
  };
}
export function buildNextPurchasePeriod(lastPeriod, company, plan) {
  const timeZone = company.timezone;
  const date = lastPeriod.periodStartdate;
  const sDate = moment
      .tz(date, timeZone)
      .add(Number(plan.purchasePeriod), 'month')
      .startOf('day');
  const eDate = sDate
      .clone()
      .add(Number(plan.purchasePeriod), 'month')
      .subtract(1, 'days')
      .endOf('day')
      .valueOf();
  const newPeriod = {
    periodStartdate: sDate.valueOf(),
    periodEnddate: eDate.valueOf(),
    companyId: company.id,
    timeZone: timeZone,
  };
  if ('enrollmentStarts' in plan && plan.enrollmentStarts) {
    newPeriod.enrollmentStartDate = sDate
        .clone()
        .subtract(plan.enrollmentStarts, 'days')
        .startOf('day')
        .valueOf();
  }
  if ('enrollmentEnds' in plan && plan.enrollmentEnds) {
    newPeriod.enrollmentEndDate = sDate
        .clone()
        .subtract(plan.enrollmentEnds, 'days')
        .subtract(1, 'days')
        .endOf('day')
        .valueOf();
  }
  return newPeriod;
}

